import { _ as __rest, u as useCollapse, a as __assign } from './useCollapse-3e159e87.js';
import React from 'react';
import cn from 'classnames';
import './utils/getCollapseStyles.js';

var styles = {"collapse":"collapse__collapse_n9o6q"};
 require('./styles/default.css')

function Collapse(_a) {
    var children = _a.children, _b = _a.open, open = _b === void 0 ? false : _b, className = _a.className, dataTestId = _a.dataTestId, onTransitionEnd = _a.onTransitionEnd, restProps = __rest(_a, ["children", "open", "className", "dataTestId", "onTransitionEnd"]);
    var _c = useCollapse(open), collapseContent = _c.collapseContent, collapseStyles = _c.collapseStyles, handlerTransitionEnd = _c.handlerTransitionEnd;
    var classNames = cn(styles.collapse, className);
    var handleTransitionEnd = function (event) {
        handlerTransitionEnd(event);
        if (onTransitionEnd) {
            onTransitionEnd(open);
        }
    };
    return (React.createElement("div", __assign({ className: classNames, "data-test-id": dataTestId, onTransitionEnd: handleTransitionEnd, ref: collapseContent, style: collapseStyles }, restProps), children));
}
Collapse.displayName = 'Collapse';

export { Collapse as default };
